/**
 * Emit hosts for the `book-demo` analytics group — 4 functions
 * lifted out of `analyticsScribeModel`'s effects so a call site can emit
 * without holding a Rematch `dispatch`. Every payload is the effect's own.
 */
import { track } from '@/lib/analytics/track';
import { TrackingEventName } from '@/models/analytics/eventTypes';
import {
  type BookDemoCliniciansSelectedEventProps,
  type BookDemoCountrySelectedEventProps,
  type BookDemoFormSubmittedEventProps,
  type BookDemoNextClickedEventProps,
} from '@/models/analytics/features/book-demo';

export function trackBookDemoCliniciansSelected(
  input: BookDemoCliniciansSelectedEventProps
) {
  track({
    event_name: TrackingEventName.BookDemoCliniciansSelected,
    props: input,
  });
}

export function trackBookDemoCountrySelected(input: BookDemoCountrySelectedEventProps) {
  track({
    event_name: TrackingEventName.BookDemoCountrySelected,
    props: input,
  });
}

export function trackBookDemoFormSubmitted(input: BookDemoFormSubmittedEventProps) {
  track({
    event_name: TrackingEventName.BookDemoFormSubmitted,
    props: {
      country_name: input.country_name,
      country_code: input.country_code,
      organisation_size: input.organisation_size,
    },
  });
}

export function trackBookDemoNextClicked(input?: BookDemoNextClickedEventProps) {
  track({
    event_name: TrackingEventName.BookDemoNextClicked,
    props: input,
  });
}
